/**
 * @description: 路由
 * @author: nowThen
 */

import Vue from 'vue';
import Router from 'vue-router';

const Error = () => import(/* webpackChunkName: "error" */ '@/views/error');

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'hello',
    component: () => import('@/views/home'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/news',
    name: 'news',
    meta: {
      title: '菜单'
    },
    component: {
      render: (h) => h('router-view')
    },
    redirect: '/news/list',
    children: [
      {
        path: 'list',
        name: 'newsList',
        component: () => import('@/views/about/newsList')
      },
      {
        path: 'detail',
        name: 'newsDetail',
        component: () => import('@/views/about/newsDetail')
      },
      {
        path: 'article',
        name: 'article',
        component: () => import('@/views/about/article')
      }
    ]
  },
  {
    path: '/women',
    name: 'women',
    meta: {
      title: '女士'
    },
    component: {
      render: (h) => h('router-view')
    },
    redirect: '/women/winter21',
    children: [
      {
        path: 'spring22',
        name: 'womenSpring22',
        component: {
          render: (h) => h('router-view')
        },
        redirect: '/women/spring22/campaign',
        children: [
          {
            path: 'campaign',
            name: 'womenSpring22Campaign',
            component: () => import('@/views/women/spring22/campaign'),
          },
          {
            path: 'lookbook',
            name: 'womenSpring22Lookbook',
            component: () => import('@/views/women/spring22/lookbook'),
          }
        ]
      },
      {
        path: 'winter21',
        name: 'womenWinter21',
        component: {
          render: (h) => h('router-view')
        },
        redirect: '/women/winter21/lookbook',
        children: [
          {
            path: 'lookbook',
            name: 'womenWinter21Lookbook',
            component: () => import('@/views/women/winter21/lookbook'),
          }
        ]
      },
      {
        path: 'autumn21',
        name: 'womenAutumn21',
        component: {
          render: (h) => h('router-view')
        },
        redirect: '/women/autumn21/campaign',
        children: [
          {
            path: 'campaign',
            name: 'womenAutumn21Campaign',
            component: () => import('@/views/women/autumn21/campaign'),
          },
          {
            path: 'lookbook',
            name: 'womenAutumn21Lookbook',
            component: () => import('@/views/women/autumn21/lookbook'),
          }
        ]
      },
    ]
  },
  {
    path: '/men',
    name: 'men',
    meta: {
      title: '男士'
    },
    component: {
      render: (h) => h('router-view')
    },
    // redirect: '/men/winter21',
    children: [
      {
        path: 'spring22',
        name: 'menSpring22',
        component: {
          render: (h) => h('router-view')
        },
        redirect: '/men/spring22/campaign',
        children: [
          {
            path: 'campaign',
            name: 'menSpring22Campaign',
            component: () => import('@/views/men/spring22/campaign'),
          },
          {
            path: 'lookbook',
            name: 'menSpring22Lookbook',
            component: () => import('@/views/men/spring22/lookbook'),
          }
        ]
      },
      {
        path: 'winter21',
        name: 'menWinter21',
        component: {
          render: (h) => h('router-view')
        },
        redirect: '/men/winter21/campaign',
        children: [
          {
            path: 'campaign',
            name: 'menWinter21Campaign',
            component: () => import('@/views/men/winter21/campaign'),
          },
          {
            path: 'lookbook',
            name: 'menWinter21Lookbook',
            component: () => import('@/views/men/winter21/lookbook'),
          }
        ]
      },
      {
        path: 'autumn21',
        name: 'menAutumn21',
        component: {
          render: (h) => h('router-view')
        },
        redirect: '/men/autumn21/campaign',
        children: [
          {
            path: 'campaign',
            name: 'menAutumn21Campaign',
            component: () => import('@/views/men/autumn21/campaign'),
          },
          {
            path: 'lookbook',
            name: 'menAutumn21Lookbook',
            component: () => import('@/views/men/autumn21/lookbook'),
          }
        ]
      },
    ]
  },
  {
    path: '/stores',
    name: 'stores',
    meta: {
      title: ''
    },
    component: {
      render: (h) => h('router-view')
    },
    redirect: '/stores/otherStores',
    children: [
      {
        path: 'otherStores',
        name: 'otherStores',
        component: () => import('@/views/stores/otherStores')
      },
      // {
      //   path: 'conceptStores',
      //   name: 'conceptStores',
      //   component: () => import('@/views/stores/conceptStores')
      // },
    ]
  },
  {
    path: '/error',
    name: 'error',
    component: Error,
    meta: {
      title: '404页'
    }
  },
  {
    path: '/redirect',
    name: 'redirect',
    component: () => import('@/views/redirect')
  },
  {
    path: '*',
    redirect: 'error'
  }
];

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// const originalReplace = Router.prototype.replace
// originalReplace.replace = function replace(location) {
//   return originalReplace.call(this, location).catch(err => err)
// }

const router = new Router({
  mode: 'history',
  // mode: 'hash',
  routes
});

export default router;
